import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StateChange } from 'ng-lazyload-image';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  projectName: string = '';
  projectTitle: string = '';
  selectedPlace: string = '';

  private selectedLocation = new BehaviorSubject('');
  currentPlace = this.selectedLocation.asObservable();

  private ViewerOpenSource = new BehaviorSubject('');
  ViewerOpen = this.ViewerOpenSource.asObservable();

  appConfig: any = {};
  webViewerWindow: any;
  ProjectLSData: any = {};


  userRoleList = this.ProjectLSData?.userRoleList || '{}';
  defaultRole = this.userRoleList ? this.userRoleList.length ? this.userRoleList[0] : '' : '';
  private currentRoleSource = new BehaviorSubject(this.defaultRole.role);
  currentRole = this.currentRoleSource.asObservable();

  constructor(private http: HttpClient, private configService: AppConfigService, private router: Router, private snackBar: MatSnackBar) {
    this.appConfig = this.configService.config;
    this.projectName = this.appConfig.projectName;
    this.projectTitle = this.appConfig?.projectTitle ? this.appConfig.projectTitle : "AiraDx";
    this.fetchProjectLSData();
  }

  fetchProjectLSData() {
    if (localStorage[this.projectName]) {
      this.ProjectLSData = JSON.parse(localStorage[this.projectName]);
    }
  }

  vwTOpx(value: any) {
    value = value.replace('vw', '');
    var w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth,
      y = w.innerHeight || e.clientHeight || g.clientHeight;

    var result = (x * value) / 100;
    return result;
  }

  editUserState(source: any, emailId: any) {
    if (source == 'Inactive') {
      return this.http.post(`${this.appConfig.apiUrl}user/enable`, emailId);
    } else {
      return this.http.post(`${this.appConfig.apiUrl}user/disable`, emailId);
    }
  }

  setCurrentPlace(place: string) {
    this.selectedLocation.next(place);
  }

  login(userCredentials: any) {
    return this.http.post(`${this.appConfig.apiUrl}user/login`, userCredentials);
  }

  createUser(newUserData: any) {
    return this.http.post(`${this.appConfig.apiUrl}user/create-user`, newUserData);
  }

  editUser(userData: any) {
    return this.http.post(`${this.appConfig.apiUrl}user/edit`, userData);
  }

  createNewUser(userData: any) {
    return this.http.post(`${this.appConfig.apiUrl}user/create`, userData);
  }

  getAllUsers() {
    return this.http.get(`${this.appConfig.apiUrl}user`);
  }

  changeOfRoutes() {
    if (location.pathname.indexOf('WebViewer') < 0) {
      if (this.ProjectLSData.currentRoute) {
        this.router.navigate([this.ProjectLSData.currentRoute]);
      } else {
        this.ProjectLSData.currentRoute = location.pathname.replace(this.appConfig.replacePathName, "");
        this.setProjectLSData();
      }
    }
  }

  savePatientMRNSheetData(patientMRNSheetData: any) {
    return this.http.post(`${this.appConfig.apiUrl}prostate/dev/uploadcsv`, patientMRNSheetData);
  }

  getAllRoles() {
    return this.http.get(`${this.appConfig.apiUrl}user/roles/all`);
  }

  sendEmailForVerification(email: any) {
    return this.http.get(`${this.appConfig.apiUrl}user/forgetUserPassword?userId=${email}`);
  }

  setViewerOpenedFrom(planceName: any) {
    this.ProjectLSData['viewerOpenedFrom'] = planceName;
    this.setProjectLSData();
    this.ViewerOpenSource.next(planceName);
  }

  setProjectLSData() {
    localStorage[this.projectName] = JSON.stringify(this.ProjectLSData);
  }

  verifyCode(requestBody: any) {
    return this.http.post(`${this.appConfig.apiUrl}user/verifyCode`, requestBody);
  }

  resetPassword(requestBody: any) {
    // http://{{Host}}:9070/qc/user/resetPassword
    return this.http.post(`${this.appConfig.apiUrl}user/resetPassword`, requestBody);
  }

  changePassword(requestBody: any) {
    return this.http.post(`${this.appConfig.apiUrl}user/changePassword`, requestBody);
  }

  showToastMsg(message: string, duration: any = 3000) {
    this.snackBar.open(message, '', {
      duration: duration,
      panelClass: 'toastMsgPanel',
      horizontalPosition: 'center',
      verticalPosition: 'top'
    })
  }

  changeRoleId(role: any) {
    this.ProjectLSData["userActiveRole"] = role;
    this.setProjectLSData();
    this.currentRoleSource.next(role);
  }

  changePlace(place: any) {
    this.ProjectLSData["sideBarPlace"] = place;
    this.setProjectLSData();
    this.selectedLocation.next(place);
  }

  reloadFailedLazyLoadImg1(event: StateChange, slideData: any, refEl: any, pathVar: any) {
    if (event.reason == 'loading-succeeded') {
      refEl.classList.remove("ng-failed-lazyloaded");
    } else if (event.reason == 'loading-failed') {
      if (this.appConfig.failedLazyloadInfo) {
        if (slideData?.retryAttempted < this.appConfig.failedLazyloadInfo.maxRetryAttempt) {
          setTimeout(() => {
            var timestamp = new Date().getTime();
            let imgPathVar = slideData[pathVar].split('?')[0];
            slideData[pathVar] = imgPathVar + '?t=' + timestamp;
            slideData.retryAttempted++;
          }, this.appConfig.failedLazyloadInfo.retryDelay);
        }
      }
    }
  }

  reloadFailedLazyLoadImg(event: StateChange, slideData: any, refEl: any, pathVar: any, isForPreview: boolean = false) {
    if (event.reason == 'loading-succeeded') {
      if (this.appConfig.macroImgInfo?.dimensionCheck && (pathVar == "macroPath") && (refEl.naturalWidth > refEl.naturalHeight) && !isForPreview && ((!slideData.macroRotation) || (slideData.macroRotation == 0))) {
        slideData.macroRotation += 90;
        refEl.style.transform = "rotate(" + slideData.macroRotation + "deg)";
        refEl.classList.add("rotatedImg");
        refEl?.parentNode?.parentNode?.getElementsByClassName("labelImg")?.[0]?.classList.add("rotatedImg");
        refEl?.parentNode?.parentNode?.getElementsByClassName("qrImagTag")?.[0]?.classList.add("rotatedImg");
      }
      refEl.classList.remove("ng-failed-lazyloaded");
    } else if (event.reason == 'loading-failed') {
      if (this.appConfig?.failedLazyloadInfo) {
        if (slideData?.retryAttempted < this.appConfig?.failedLazyloadInfo?.maxRetryAttempt) {
          setTimeout(() => {
            var timestamp = new Date().getTime();
            let imgPathVar = slideData[pathVar].split('?')[0];
            slideData[pathVar] = imgPathVar + '?t=' + timestamp;
            slideData.retryAttempted++;
          }, this.appConfig?.failedLazyloadInfo.retryDelay);
        }
      }
    }
  }

  checkIfImageExists(url: string, callback: any) {
    const img = new Image();
    img.src = url;

    if (img.complete) {
      callback(true);
    } else {
      img.onload = () => {
        callback(true);
      };

      img.onerror = () => {
        callback(false);
      };
    }
  };

  setRowColors(row: any, isBGColor: boolean = false) {
    let styleObj: any = {};
    if (row.rejected) {
      styleObj[isBGColor ? 'background-color' : 'color'] = this.appConfig?.patientListStatusColors?.RejectedMRN;
    } else if (this.appConfig?.patientListStatusColors?.[row.caseStatus]) {
      styleObj[isBGColor ? 'background-color' : 'color'] = this.appConfig?.patientListStatusColors?.[row.caseStatus];
    } else {
      styleObj[isBGColor ? 'background-color' : 'color'] = '';
    }

    return styleObj;
  }

  containsCharsStrict(inputStr: string, mainStr: string) {
    const freq: any = {};

    // normalize target mainStr
    for (const ch of mainStr.toLowerCase()) {
      freq[ch] = (freq[ch] || 0) + 1;
    }

    // check input characters
    for (const ch of inputStr.toLowerCase()) {
      if (!freq[ch]) {
        return false;
      }
      freq[ch]--;
    }

    return true;
  }

}
